import { render, staticRenderFns } from "./SosButton.vue?vue&type=template&id=4bcf5474&lang=pug"
import script from "./SosButton.vue?vue&type=script&lang=js"
export * from "./SosButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports